import React from 'react';
import KickImage from 'Reuseables/KickImage';

import ModalSizeChart from './ModalSizeChart';
import { ButtonParagraf, Wrapper } from '../../../../../../../reusablestyled';

class SizeChart extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.onToggleModalChart = this.onToggleModalChart.bind(this);
  }

  onToggleModalChart() {
    this.props.flaggingIsOpenSizeChart(!this.state.isOpen)
    this.setState({ isOpen: !this.state.isOpen }, () => {
      if (this.state.isOpen) {
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";

      } else {
        document.body.style.overflow = "scroll";
        document.body.style.position = "initial";
      }
    })
  }

  render() {
    return (
      <Wrapper>
        <ModalSizeChart isOpen={this.state.isOpen} onToggle={this.onToggleModalChart} category={this.props.category} />
        <ButtonParagraf type='button' onClick={() => this.onToggleModalChart()} style={this.props.style}>Size Chart</ButtonParagraf>
      </Wrapper>
    )
  }
}

export default SizeChart;
